import * as React from "react";
const SvgWorkstation24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "black",
        viewBox: "0 0 24 24"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M6 0H5v9h14V0h-5v2h-4V0H6Zm10 3V2h1v5H7V2h1v2h8V3ZM0 14h3v10h2V14h14v10h2V14h3v-2H0v2Z",
      clipRule: "evenodd"
    })
  );
export default SvgWorkstation24Px;
